import { AuthService } from './auth.service';
export abstract class ResetFiltersService {
    constructor(protected authService: AuthService) {
        this.authService.logout$.subscribe(() => {
            this.resetFilter();
        });
    }

    abstract resetFilter(): void;
}
